module.exports = __webpack_public_path__ + "static/media/stock-photo-uncooked-rice-in-a-bowl-on-a-white-background-128613017.5c02436d.jpg";